import React, { useState } from 'react'
import { PublicWrapper } from 'src/components/layout/PublicWrapper'
import { Navigate } from 'react-router-dom'
import { ROUTES } from 'src/constants/routes'
import { useDispatch, useSelector } from 'react-redux'
import { SignUpForm } from 'src/components/auth/sign-up-form/SignUpForm'
import { getInvite } from 'src/selectors/invite'
import { SignUpFormValues } from 'src/components/auth/sign-up-form/SignUpForm.interface'
import { createAsyncAction } from 'src/utils/reduxUtils'
import { SignUp } from 'src/constants/actionTypes'
import { handleApiError } from 'src/utils/errorHandlers'

export const SignUpPage = () => {
  const dispatch = useDispatch()

  const invite = useSelector(getInvite)

  const [isLoading, setIsLoading] = useState<boolean>(false)

  const handleFormSubmit = async (values: SignUpFormValues) => {
    if (!invite) {
      return
    }

    setIsLoading(true)

    try {
      const { email, firstName, lastName, id } = invite

      await createAsyncAction(
        dispatch,
        SignUp.request({ email, firstName, lastName, inviteId: id, ...values }),
      )
    } catch (err: any) {
      handleApiError(err)
    } finally {
      setIsLoading(false)
    }
  }

  if (!invite) {
    return <Navigate to={ROUTES.SIGN_IN_URL} />
  }

  return (
    <PublicWrapper>
      <div data-testid="sign-up-page">
        <SignUpForm isLoading={isLoading} onSubmit={handleFormSubmit} />
      </div>
    </PublicWrapper>
  )
}
